/**
 * Created by Dhanya Akhil on 3/1/2017.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { SendWelcomeMailRoutingModule } from './send-welcomemail-routing.module';
import { SendWelcomeMailComponent } from './components/send-welcomemail.component';
import { SendWelcomeMailService } from "./services/send-welcomemail.service";

@NgModule({
  imports: [
    CommonModule,
    SendWelcomeMailRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule.forRoot(),
    TranslateModule.forChild()
  ],
  declarations: [SendWelcomeMailComponent],
  exports:[FormsModule,ReactiveFormsModule],
  providers: [SendWelcomeMailService]
})
export class SendWelcomeMailModule {
}
